import {componentStylesAndSkinsAPI} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {dataManipulation, getter}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                cssStyle: {
                    update: dataManipulation('components.cssStyle.update'),
                    get: getter('components.cssStyle.get'),
                    remove: dataManipulation('components.cssStyle.remove')
                },
                style: {
                    getId: publicMethodUtils.defineGetter(componentStylesAndSkinsAPI.style.getId),
                    get: publicMethodUtils.defineGetter(componentStylesAndSkinsAPI.style.get),
                    update: publicMethodUtils.defineDataManipulationAction(componentStylesAndSkinsAPI.style.update),
                    connectToTheme: publicMethodUtils.defineDataManipulationAction(
                        componentStylesAndSkinsAPI.style.connectToThemeStyle
                    ),
                    scoped: {
                        remove: publicMethodUtils.defineDataManipulationAction(
                            componentStylesAndSkinsAPI.style.removeScoped
                        )
                    },
                    fork: publicMethodUtils.defineDataManipulationAction(componentStylesAndSkinsAPI.style.fork)
                },
                getColorsListInAllComponents: publicMethodUtils.extensionPublicAPI.getter(
                    'style.getColorsListInAllComponents'
                ),
                replaceColorInAllComponents: publicMethodUtils.extensionPublicAPI.dataManipulation(
                    'style.replaceColorInAllComponents'
                )
            }
        }
    }
}
